// Liberação gradual do Clube de Benefícios: por enquanto só o perfil Cliente Fiel enxerga a tela
// (para configurar e ativar o clube das lojas). O administrador da loja só passa a ver depois que o
// clube dela está ativo — o backend grava PUBLIC_CLUBE_BENEFICIOS_ATIVO ao salvar a configuração.

export const clubeBeneficiosAtivoNaLoja = (parametros: any): boolean =>
    parametros?.PUBLIC_CLUBE_BENEFICIOS_ATIVO === true || parametros?.PUBLIC_CLUBE_BENEFICIOS_ATIVO === "true"

export const clubeBeneficiosLiberado = (perfil: string | undefined, parametros: any): boolean => {
    if (perfil === "CLIENTEFIEL") return true
    return perfil === "ADMINISTRADOR" && clubeBeneficiosAtivoNaLoja(parametros)
}
